import { SyntheticEvent, useContext, useState } from "react";

import { useTranslation } from "react-i18next";

import AuthContext from "context/auth/authContext";
import { AUTHENTICATION_TYPES } from "shared";

export const useTwoFactorVerification = () => {
    const { authType, loginUser } = useContext(AuthContext);

    const { t } = useTranslation();

    const [otpCode, setOtpCode] = useState("");
    const [recoveryCode, setRecoveryCode] = useState("");
    const [error, setError] = useState<string | null>(null);
    const [isRecoveryCodePhase, setIsRecoveryCodePhase] = useState(false);

    const handleRecoveryCodePhase = (value: boolean) =>
        setIsRecoveryCodePhase(value);

    const handleOtpChange = (newValue: string) => {
        setError(null);
        setOtpCode(newValue);
    };

    const handleRecoveryCodeChange = (newValue: string) => {
        setError(null);
        setRecoveryCode(newValue);
    };

    const handleSubmit = (e: SyntheticEvent) => {
        e.preventDefault();

        loginUser({
            payload: {
                otp_code: isRecoveryCodePhase ? recoveryCode : otpCode,
                two_factor_auth_type: isRecoveryCodePhase
                    ? AUTHENTICATION_TYPES.RecoveryCode
                    : authType!
            },
            is2Fa: true,
            badRequestCallback: () =>
                setError(t("Security##2FA##send otp code##incorrect code"))
        });
    };

    const resetError = () => setError(null);

    return {
        otpCode,
        recoveryCode,
        twoFaError: error,
        isRecoveryCodePhase,
        handleRecoveryCodePhase,
        handleOtpChange,
        handleRecoveryCodeChange,
        handle2FaSubmit: handleSubmit,
        resetOtpError: resetError
    };
};
